import React from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography } from '@material-ui/core';
import { hasPermission, formatDate } from '../../../sc-utilities';
import ProductPaletteHistoryList from './ProductPaletteHistoryList';

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        marginTop: '-20px',
        paddingTop: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    }
});

const ProductPaletteHistory = props => {
    const tableRef = React.createRef();
    const { classes, columns, translations, permissions, productID } = props;
    let visible = columns && columns['ProductPaletteHistory'];

    let tableColumns = [
        {
            title: translations["colli"] || 'Colli', field: 'ColliName',
            hidden: visible ? visible['ColliName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Colli && rowData.Colli.Name ? rowData.Colli.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["transport_collies"] || 'Transport collies', field: 'TransportColliName',
            hidden: visible ? visible['TransportColliName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.TransportColli ? rowData.TransportColli.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["order"] || 'Order', field: 'OrderName',
            hidden: visible ? visible['OrderName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Order && rowData.Order.Name ? rowData.Order.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["stored_by"] || 'Stored by', field: 'CreatedBy',
            hidden: visible ? visible['CreatedBy'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.User && rowData.User.Username ? rowData.User.Username : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["stored_at"] || 'Stored at', field: 'CreatedAt',
            hidden: visible ? visible['CreatedAt'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.CreatedAt ? formatDate(rowData.CreatedAt) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        }
    ];

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'product_view_history') ?
                <ProductPaletteHistoryList
                    productID={productID}
                    tableColumns={tableColumns}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(ProductPaletteHistory));